<template>
  <div class="container g-flex g-row-center" v-loading="submiting">
    <div class="total-width white-bg g-m-t-30">
      <div class="g-p-30 g-flex g-col-top">
        <!--  左侧信息  -->
        <div class="left-info g-rela">
          <div class="title g-rela g-flex g-row-center g-weight-font g-font-24">
            线上实操考试
          </div>
          <div class="g-flex g-row-center">
            <div>
              <div class="g-m-t-40 g-flex">
                <img src="@/assets/examination/subjects-icon.png" class="left-icon" alt="">
                <p class="g-m-l-15">科目：{{ paperName }}</p>
              </div>
              <div class="g-m-t-15 g-flex">
                <img src="@/assets/examination/level-icon.png" class="left-icon" alt="">
                <p class="g-m-l-15">等级：{{ testLevel }}</p>
              </div>
            </div>
          </div>
          <!--  分割线  -->
          <div class="dash-line g-m-t-35"></div>
          <div class="g-m-t-20 remark-text g-font-14 g-p-b-30">
            考试提醒：考生请注意，在考试途中请不要切换浏览器窗口或切换应用，若中途关闭浏览器窗口则视为放弃考试！
          </div>
        </div>

        <!--  右侧上传  -->
        <div class="g-m-l-70 right-container">
          <div class="g-flex ">
            <span class="blue-point"></span>
            <p class="g-m-l-10 main-text g-font-22">请上传实操视频</p>
          </div>
          <div class="g-m-l-18">
            <div class="g-flex g-m-t-20">
              <!--  上传按钮  -->
<!--              <img src="@/assets/examination/upload-img.jpg" class="upload-img" alt="">-->

              <el-upload v-loading="uploading" element-loading-text="上传中。。。"
                  :action="uploadUrl"
                  :headers="headers"
                  :multiple="false"
                   :before-upload="handleBeforeUpload"
                   :disabled="disabled"
                   :on-error="handleError"
                  :on-success="handleAvatarSuccess"
                   :on-progress="handleProgress"
                  :show-file-list="false"
                  list-type="picture-card"
                  :accept="fileType">
                <i class="el-icon-plus" v-if="!videoPath"></i>
                <div class="g-rela" @mouseenter="doAnimate" @mouseleave="endAnimate">
<!--                  <div class="mask g-flex g-row-center " v-if="isHover" @click="delVideo">
                    <img src="@/assets/examination/del-img.png" class="del-img pointer" alt="">
                  </div>-->
                  <video v-if="videoPath" id="media"  height="150px" width="240px" controls>
                    <source :src="videoPath" type="video/mp4">
                  </video>
                </div>
              </el-upload>
              <!--  上传的视频  -->
<!--              <div class="g-rela g-m-l-40" @mouseenter="doAnimate" @mouseleave="endAnimate">
                <div class="mask g-flex g-row-center " v-if="isHover" @click="delVideo">
                  <img src="@/assets/examination/del-img.png" class="del-img pointer" alt="">
                </div>
                <video v-if="videoPath" id="media"  height="150px" width="240px" preload>
                  <source :src="videoPath" type="video/mp4">
                </video>
              </div>-->
            </div>
            <div class="g-m-t-16 g-font-14">
              <p class="main-text g-weight-font">提示</p>
              <p class=" remark-text">1、仅支持上传 .mp4格式文件；</p>
              <p class=" remark-text">2、仅支持上传1个文件，视频长度1分钟-3分钟，视频大小不超过50MB。</p>
              <div class="g-m-t-20 btn" @click="goSubmit">
                交    卷
              </div>
              <div class="g-m-t-20 clear-btn" @click="clearVideo" v-if="videoPath" style="margin-left: 10px">
                清    空
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Base64} from "@/utils/base64";
import config from "@/api/config";
import {subOperate} from "@/api/education/paper"
import {Message} from "element-ui";
export default {
  name: "online-operation",
  data(){
    return{
      uploading:false,
      uploadUrl: config.baseUrl + '/blade-resource/oss/endpoint/put-file',
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      submiting:false,
      fileType:"video/mp4,audio/mp4",
      fileTypes:["video/mp4","audio/mp4"],
      isHover:false,
      paperId: this.$route.query.paperId,
      testLevel: this.$route.query.testLevel,
      paperName: this.$route.query.paperName,
      videoPath:'',//视频上传地址
      operateData:{}
    }
  },
  computed:{
    headers() {
      return {
        'Blade-Auth':  'bearer ' + this.$store.state.accessToken,
        'Authorization': 'Basic ' + Base64.encode('sword:sword_secret')
      }
    }
  },
  methods:{
      handleAvatarSuccess(res, file){
        this.uploading=false
        this.disabled=true
        this.videoPath = res.data.link;
      },
      handleBeforeUpload(file){
        if(file.size/1024/1024>50){
          Message.error("上传文件超出大小限制！")
          return false;
        }
        if(this.fileTypes.indexOf(file.type)<0){
          Message.error("文件类型不匹配！")
          return false;
        }
        console.log(file)
      },
      handleError(){
        this.uploading=false
        this.disabled=false
        Message.error("上传文件失败！")
      },
      handleProgress(){
        this.uploading=true
      },
      handleRemove(file) {
        this.videoPath=null
        this.disabled=false
        console.log(file);
      },
      clearVideo(){
        this.videoPath=null
        this.disabled=false
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleDownload(file) {
        console.log(file);
      },
    //鼠标移入的事件
    doAnimate(){
      setTimeout(()=>{
        this.isHover = true
      },100)
    },
    //  鼠标移除事件
    endAnimate(){
      setTimeout(()=>{
        this.isHover = false
      },100)
    },
    // 删除上传的视频
    delVideo(){
      this.videoPath = null
      this.disabled=false
    },
    // 跳转提交成功
    goSubmit(){
        this.submiting=true
        this.operateData.paperId=this.paperId;
        this.operateData.subject=this.paperName;
        this.operateData.videoPath=this.videoPath
      if(!this.operateData.videoPath){
        Message.error("请先上传视频再提交！");
        this.submiting=false
        return;
      }
      subOperate(this.operateData).then(res=>{
        this.submiting=false
        this.$router.push({
          name:'online-operation-submit',
          params: {
            paperId:this.paperId,
            videoUrl:this.videoPath
          }
        })
      },error => {
        this.submiting=false
        Message.error("提交失败，请稍后重试！");
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .white-bg{
    border-radius: 5px;
    background: #fff;
  }

  .left-info{
    background: #f6f6f8;
    border-radius: 5px;
    padding:0 30px;
    width: 393px;

    .title{
      background-image: url("../../assets/course-list/course-title-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 306px;
      height: 91px;
      color: #fff;
      margin: -20px auto 0 auto;
    }

    .left-icon{
      width: 35px;
      height: 35px;
    }

    .dash-line{
      border-top: 1px dashed #407aff;
      width: 100%;
    }
  }

  .right-container{

    .blue-point{
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #407AFF;
    }

    .upload-img{
      width: 150px;
      height: 150px;
    }


    .mask{
      background: rgba(0,0,0,0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 240px;
      height: 150px;
      cursor: pointer;
    }

    .del-img{
      width: 39px;
      height: 39px;
    }

    video{
      width: 240px;
      height: 150px;
      object-fit: fill;
    }

    .btn{
      background: #407aff;
      border-radius: 5px;
      color: #fff;
      padding: 8px 20px;
      display: inline-block;
      cursor: pointer;
    }
    .clear-btn{
      background: #e80101;
      border-radius: 5px;
      color: #fff;
      padding: 8px 20px;
      display: inline-block;
      cursor: pointer;

    }
  }

</style>
